import Link from 'next/link'
import usePortalShutdown from 'web/hooks/usePortalShutdown'
import { ContractData } from 'web/lib/contract'

interface GallyerHeaderProps {
  title: string
  initContractData: ContractData
  showBloodBeta?: boolean
}
export default function GalleryHeader({ title, initContractData, showBloodBeta }: GallyerHeaderProps) {

  const portal = usePortalShutdown(initContractData)

  // Gallery page or 404 page
  // OR loading interstitial, but we should fix that
  return (
    <div className="space-y-8 md:space-y-16 text-center">
      <div className="space-y-8">
        <h1 className="text-3xl md:text-4xl">{title}</h1>

        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 justify-center w-full mx-auto">
          {portal.canPurchase &&
            <Link href="/">
              <button className="primaryButton">Summon a Gawd</button>
            </Link>
          }
        </div>
      </div>
    </div>
  )
}
